/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBigUpLineFilled = createReactComponent("filled", "arrow-big-up-line-filled", "IconArrowBigUpLineFilled", [["path", { "d": "M10.586 3l-6.586 6.586a2 2 0 0 0 -.434 2.18l.068 .145a2 2 0 0 0 1.78 1.089h2.586v5a1 1 0 0 0 1 1h6l.117 -.007a1 1 0 0 0 .883 -.993l-.001 -5h2.587a2 2 0 0 0 1.414 -3.414l-6.586 -6.586a2 2 0 0 0 -2.828 0z", "key": "svg-0" }], ["path", { "d": "M15 20a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-1" }]]);

export { IconArrowBigUpLineFilled as default };
//# sourceMappingURL=IconArrowBigUpLineFilled.mjs.map
